interface Dictionary<T> {
  [key: string]: T
}

type Categories = 'Familien' | 'Nice Price' | 'Stadt' | 'Ferien' | 'Wellness'
export const categories: Dictionary<[string, string, string]> = {
  'Ferien': ['#9C1249', '#D01962', '#202346'],
  'Nice Price': ['#A25F15', '#D97E00', '#202346'],
  'Wellness': ['#217977', '#2CA29F', '#202346'],
  'Stadt': ['#5E1E5A', '#7E2979', '#202346'],
  'Familien': ['#356D48', '#479260', '#202346']
}
